// デフォルト設定
Chart.defaults.borderColor = '#D9D9D9';
Chart.defaults.color = '#0E0D0D';
Chart.defaults.font.family = "goldwingrotesk-regular, 'Noto Sans JP', '游ゴシック体', YuGothic, '游ゴシック Medium', 'Yu Gothic Medium', '游ゴシック', 'Yu Gothic', 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Meiryo, sans-serif";

window.addEventListener('load', () => {
  // =========
  // チャート01
  // =========
  const myChart01 = new Chart(document.getElementById('myChart01'), {
    type: 'doughnut',
    data: {
      labels: ['パフォーマンス', 'ライフスタイル', 'ファッション'],
      datasets: [
        {
          data: [29.6, 59.8, 9.5],
          backgroundColor: ['#4c5f63', '#547b83', '#7292a9'],
        },
      ],
    },
    options: {
      cutout: '60%',
      animation: false,
      plugins: {
        // ツールチップ（共通）
        tooltip: {
          enabled: true,
          displayColors: false,
          padding: {
            top: 10,
            right: 9,
            bottom: 10,
            left: 9,
          },
          backgroundColor: 'rgba(38, 38, 38, 0.9)',
          titleFont: {
            size: 14, // ツールチップのフォントサイズを指定
          },
          bodyFont: {
            size: 14, // ツールチップのフォントサイズを指定
          },
        },
        legend: {
          display: true,
          position: 'top',
          align: 'start',
          onClick: function () {
            return false;
          },
          labels: {
            font: {
              size: 12,
            },
            boxWidth: 38,
            boxHeight: 10,
            // ラベル横にデータ値を表示する
            generateLabels: function (chart) {
              const data = chart.data;
              if (data.labels.length && data.datasets.length) {
                const {
                  labels: { pointStyle },
                } = chart.legend.options;

                const max = data.datasets[0].data.reduce((a, b) => a + b, 0);

                return data.labels.map((label, i) => {
                  const meta = chart.getDatasetMeta(0);
                  const style = meta.controller.getStyle(i);

                  return {
                    text: `${label} （${((data.datasets[0].data[i] * 100) / max).toFixed(1)}%）`,
                    fillStyle: style.backgroundColor,
                    strokeStyle: style.borderColor,
                    lineWidth: style.borderWidth,
                    pointStyle: pointStyle,
                    hidden: !chart.getDataVisibility(i),

                    // Extra data used for toggling the correct item
                    index: i,
                  };
                });
              }
              return [];
            },
          },
        },
      },
    },
    plugins: [
      {
        beforeInit(chart) {
          // Get a reference to the original fit function
          const originalFit = chart.legend.fit;
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call the original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in other answers
            this.height += 22;
          };
        },
      },
    ],
  });
  // end
});
